import React from 'react';
import Button from "../elements/Button";

const VoiceRegister = (props) => {

    return (
        <div className="row">
            <div className="col-md-6 col-md-offset-3 col-xs-12 centered">
                <p>Call us now to order. Or let us call you.</p>
                <Button
                    image="/images/btn-phone-noborder.svg"
                    alt="Call us"
                    action="tel: 1300393835"
                />
                <Button
                    action={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null}
                    image="/images/btn-get-in-touch-midgreen.svg"
                    alt="Leave your details"
                />
            </div>
        </div>
    );

};

export default VoiceRegister;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/VoiceRegister.js